(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalSidebar', ['$rootScope', RfGlobalSidebarFn]);

    /* main sidebar directive */
    function RfGlobalSidebarFn($rootScope) {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/global/templates/rf-global-sidebar.template.html',
            controller: 'SidebarController',
            controllerAs: 'vm',
            scope: true,
            link: link
        };

        function link(scope, element) {
            var body = $('body');
            var sidebar = $('.page-sidebar');
            var sidebarMenu = $('.page-sidebar-menu');
            var resBreakpointMd = App.getResponsiveBreakpoint('md');

            if (body.hasClass("page-sidebar-closed")) {
                sidebarMenu.addClass("page-sidebar-menu-closed");
                sidebarMenu.trigger("mouseleave");
            }

            // calendar nav
            var calNav = $('#calendarNav');

            // deregister metronic event-handler
            $('body').off('click', '.sidebar-toggler');

            // own event-handler
            $('body').on('click', '.sidebar-toggler', function (e) {
                if (body.hasClass("page-sidebar-closed")) {
                    body.removeClass("page-sidebar-closed");
                    sidebarMenu.removeClass("page-sidebar-menu-closed");
                    calNav.addClass("hide");
                    if (Cookies) {
                        Cookies.set('sidebar_closed', '0');
                    }
                } else {
                    body.addClass("page-sidebar-closed");
                    sidebarMenu.addClass("page-sidebar-menu-closed");
                    calNav.removeClass("hide");
                    if (body.hasClass("page-sidebar-fixed")) {
                        sidebarMenu.trigger("mouseleave");
                    }
                    if (Cookies) {
                        Cookies.set('sidebar_closed', '1');
                    }
                }

                $(window).trigger('resize');
                e.stopPropagation();
                e.preventDefault();
            });


            // toggle the sidebar on state-change
            $rootScope.$on('$stateChangeSuccess', function () {
                if (App.getViewPort().width < resBreakpointMd && $('.page-sidebar').hasClass("in")) { // close the menu on mobile view while loading a page 
                    
                    $(".sidebar-search", sidebar).removeClass("open");

                    if (body.hasClass("page-sidebar-closed")) {
                        body.removeClass("page-sidebar-closed");
                        sidebarMenu.removeClass("page-sidebar-menu-closed");
                        calNav.addClass("hide");
                        if (Cookies) {
                            Cookies.set('sidebar_closed', '0');
                        }
                    } else {
                        body.addClass("page-sidebar-closed");
                        sidebarMenu.addClass("page-sidebar-menu-closed");
                        calNav.removeClass("hide");
                        if (body.hasClass("page-sidebar-fixed")) {
                            sidebarMenu.trigger("mouseleave");
                        }
                        if (Cookies) {
                            Cookies.set('sidebar_closed', '1');
                        }
                    }

                    $(window).trigger('resize');

                    $('.page-header .responsive-toggler').click();
                }
            });
        }

        return directive;

    }

})();